import React from 'react';
import Paper from '@material-ui/core/Paper';
import { t } from 'ttag';
import { useMutation } from '@apollo/react-hooks';
import DataTable from '../../../components/DataTable';
import { CERTIFICATION_STATUS_TITLE, USER_TYPES } from '../../../utils/enums';
import useApi from '../../../api';
import useDataList from '../../../hooks/useDataList';
import useUser from '../../../auth/hooks';
import {
  formatPublicDateRange,
  insertAt,
  isIntersection,
} from '../../../utils/helpers';
import { useNavigator } from '../../../components/Navigator';
import router from '../../../api/router';
import useNotifier from '../../../components/Messages/hooks';
import { extractDataError } from '../../../utils/errors';

const ListView = () => {
  const navigate = useNavigator();
  const api = useApi();
  const { user } = useUser();
  const { data, loading, onEdit, onAdd, refetch } = useDataList({
    schema: api.schema.certifications,
    router: api.router.certifications,
  });
  const pushMessage = useNotifier();

  const columns = [
    { title: t`Id`, field: 'id', editable: 'never' },
    { title: t`Назва`, field: 'name' },
    {
      title: t`Вид спорту`,
      field: 'section',
      render: ({ sectionObj }) => (sectionObj && sectionObj.name) || '',
    },
    {
      title: t`Дата`,
      field: 'createData',
      render: ({ startedAt, closedAt }) =>
        formatPublicDateRange(startedAt, closedAt),
    },
    {
      title: t`Статус`,
      field: 'status',
      render: ({ status }) => CERTIFICATION_STATUS_TITLE[status],
    },
  ];

  const adminColumns = [
    { title: t`Клуб`, field: 'club', render: ({ club }) => club.shortName },
  ];
  user.isAdmin && insertAt(columns, 1, ...adminColumns);

  const [unDelete] = useMutation(api.schema.certifications.undelete()[0], {
    onCompleted: (d) => {
      const { undeleteCertifications: res } = d;
      if (res.ok) {
        pushMessage({ text: 'Екзамен розархівонаний' });
        refetch();
      } else {
        const dataError = extractDataError(res.errors);
        pushMessage({ text: dataError });
      }
    },
  });
  const [Delete] = useMutation(api.schema.certifications.delete()[0], {
    onCompleted: (d) => {
      const { deleteCertifications: res } = d;
      if (res.ok) {
        pushMessage({ text: 'Екзамен заархівований' });
        refetch();
      } else {
        const dataError = extractDataError(res.errors);
        pushMessage({ text: dataError });
      }
    },
  });
  return (
    <Paper>
      <DataTable
        isLoading={loading}
        title={t`Список Екзаменів`}
        columns={columns}
        data={data || []}
        onAdd={
          isIntersection(user.types, [
            USER_TYPES.superManager,
            USER_TYPES.manager,
          ]) || user.isAdmin
            ? onAdd
            : null
        }
        onEdit={
          isIntersection(user.types, [
            USER_TYPES.superManager,
            USER_TYPES.manager,
          ]) || user.isAdmin
            ? onEdit
            : null
        }
        onRank={
          user.isAdmin
            ? (event, rowData) =>
                navigate(router.admin.certifications.athleteList(rowData.id))
            : (event, rowData) =>
                navigate(router.cabinet.certifications.athleteList(rowData.id))
        }
        onDeleteCer={
          isIntersection(user.types, [
            USER_TYPES.superManager,
            USER_TYPES.manager,
          ]) || user.isAdmin
            ? (event, rowData) => Delete({ variables: { id: rowData.id } })
            : null
        }
        unDeleteCer={
          isIntersection(user.types, [
            USER_TYPES.superManager,
            USER_TYPES.manager,
          ]) || user.isAdmin
            ? (event, rowData) => unDelete({ variables: { id: rowData.id } })
            : null
        }
      />
    </Paper>
  );
};

export default ListView;
